var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":_vm.buttonClick}},[(_vm.isPrimed)?_c('span',[_vm._v(" Click again to confirm "),(_vm.cooldown)?_c('strong',[_vm._v("(wait 1 sec)")]):_vm._e()]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }